import { render, staticRenderFns } from "./BasketFullScreen-gt3.vue?vue&type=template&id=5ebdf428&scoped=true"
import script from "./BasketFullScreen-gt3.vue?vue&type=script&lang=js"
export * from "./BasketFullScreen-gt3.vue?vue&type=script&lang=js"
import style0 from "./BasketFullScreen-gt3.vue?vue&type=style&index=0&id=5ebdf428&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebdf428",
  null
  
)

export default component.exports